import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "../../../assets/css/dashboard.css";
import SalesRep from "../forms/SalesRep";

const RequestUnderwriter = (props) => {
  return (
    <div>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Add a sales repesentative</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SalesRep />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default RequestUnderwriter;
